import { doGet, doPost } from '../http/httpHelper';

export const getUploadHistory = async (limit = 50) => {
    const safeLimit = Number.isFinite(Number(limit))
        ? Math.max(1, Math.min(200, Number(limit)))
        : 50;
    const url = `/uploadHistory?page=0&pageSize=${safeLimit}`;

    const resp = await doGet(url, { cache: true, expireInSeconds: 30 });

    if (!resp) return [];

    if (resp.httpStatus && resp.httpStatus !== 200) {
        const message =
            (typeof resp.body === 'string' && resp.body) ||
            resp.body?.message ||
            'Falha ao buscar histórico de uploads.';
        throw new Error(message);
    }

    const data = resp?.body?.data;
    return Array.isArray(data) ? data : [];
};

export const rollbackLatestSnapshot = async () => {
    const resp = await doPost('/uploadRollbackLatest', {});

    if (!resp) {
        throw new Error('Falha ao executar rollback.');
    }

    if (resp.httpStatus && resp.httpStatus !== 200) {
        const message =
            (typeof resp.body === 'string' && resp.body) ||
            resp.body?.message ||
            'Falha ao executar rollback.';
        throw new Error(message);
    }

    return resp?.body ?? resp;
};
